import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() => ({
    widget: {
        backgroundImage: 'linear-gradient(to bottom, #1f2533, #0e1117)',
        width: '100%',
        height: '100%',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
    },
    topBar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    notes: {
        marginTop: '20px',
        overflow: 'auto',
        paddingBottom: 150,

        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
}))
